import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const authInstance = axios.create({ baseURL: API_URL });
authInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('streamToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const pub = axios.create({ baseURL: API_URL });

class SeoService {
  // ---- public (front-end rendering) ----
  async getMeta(path) {
    const { data } = await pub.get('/seo/meta', { params: { path: path || '/' } });
    return data.data;
  }
  async getConfig() {
    const { data } = await pub.get('/seo/config');
    return data.data;
  }
  async getFaqs(path) {
    const { data } = await pub.get('/seo/faqs', { params: path ? { path } : {} });
    return data.data;
  }

  // ---- admin ----
  async getAdminConfig() {
    const { data } = await authInstance.get('/seo/admin/config');
    return data.data;
  }
  async updateConfig(patch) {
    const { data } = await authInstance.put('/seo/admin/config', patch);
    return data.data;
  }
  async uploadOgImage(file) {
    const fd = new FormData();
    fd.append('image', file);
    const { data } = await authInstance.post('/seo/admin/og-image', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data.data;
  }

  async getPages() {
    const { data } = await authInstance.get('/seo/admin/pages');
    return data.data;
  }
  async savePage(page) {
    const { data } = page.id
      ? await authInstance.put(`/seo/admin/pages/${page.id}`, page)
      : await authInstance.post('/seo/admin/pages', page);
    return data.data;
  }
  async deletePage(id) {
    await authInstance.delete(`/seo/admin/pages/${id}`);
  }

  async getAdminFaqs() {
    const { data } = await authInstance.get('/seo/admin/faqs');
    return data.data;
  }
  async saveFaq(faq) {
    const { data } = faq.id
      ? await authInstance.put(`/seo/admin/faqs/${faq.id}`, faq)
      : await authInstance.post('/seo/admin/faqs', faq);
    return data.data;
  }
  async deleteFaq(id) {
    await authInstance.delete(`/seo/admin/faqs/${id}`);
  }

  async preview(path) {
    const { data } = await authInstance.get('/seo/admin/preview', { params: { path } });
    return data.data;
  }
}

const service = new SeoService();
export default service;
